import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';

@Injectable()
export class DebtCollectionCommandHandlerResolver extends CommandHandlerResolver {
  constructor() {
    super();
  }
}
